import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Fieldset, Radio } from '@digdir/designsystemet-react';
import { SettingsSection } from '../../../components/TeamSettingsLayout';
import { BusinessTextField, bind, SectionProps } from './BusinessTextField';
import { HEALTH_SERVICE_ANSWERS } from './businessView';
import classes from './OrganizationBusinessPage.module.css';

/** The working environment committee and the occupational health service */
export const CommitteeSection = (props: SectionProps): ReactElement => {
  const { form, onChange } = props;
  const { t } = useTranslation();
  return (
    <SettingsSection headingId="business-committee" title={t('organizationBusiness.committee.title')}>
      <Fieldset className={classes.choices}>
        <Fieldset.Legend>{t('organizationBusiness.committee.hasCommittee')}</Fieldset.Legend>
        {[true, false].map((answer) => (
          <Radio
            key={String(answer)}
            name="business-hasCommittee"
            label={t(answer ? 'organizationBusiness.committee.yes' : 'organizationBusiness.committee.no')}
            checked={form.hasCommittee === answer}
            onChange={() => onChange({ hasCommittee: answer })}
          />
        ))}
      </Fieldset>
      {form.hasCommittee && (
        <div className={classes.pair}>
          <BusinessTextField
            {...bind('committeeLeaderName', props)}
            label={t('organizationBusiness.committee.leader')}
            autoComplete="name"
          />
          <BusinessTextField
            {...bind('committeeNextMeeting', props)}
            type="date"
            label={t('organizationBusiness.committee.nextMeeting')}
          />
        </div>
      )}
      <Fieldset className={classes.choices}>
        <Fieldset.Legend>{t('organizationBusiness.committee.healthService')}</Fieldset.Legend>
        {HEALTH_SERVICE_ANSWERS.map((answer) => (
          <Radio
            key={answer}
            name="business-healthService"
            label={t(`organizationBusiness.committee.healthServiceAnswers.${answer}`)}
            checked={form.healthService === answer}
            onChange={() => onChange({ healthService: answer })}
          />
        ))}
      </Fieldset>
      {form.healthService === 'YES' && (
        <div className={classes.pair}>
          <BusinessTextField
            {...bind('healthServiceName', props)}
            label={t('organizationBusiness.committee.healthServiceName')}
          />
          <BusinessTextField
            {...bind('healthServiceContact', props)}
            label={t('organizationBusiness.committee.healthServiceContact')}
            autoComplete="name"
          />
        </div>
      )}
    </SettingsSection>
  );
};
